
import { mapGetters } from 'vuex'
import { PageData } from '~/domain/interfaces/PageDataTypes'
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'

export default defineComponent({
  layout: 'blog',
  name: 'ArticlesIndex',
  extends: MachinationsLightPage,
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    const pageData = this.pageData as PageData
    const yoastDescription = pageData?.yoast_head_json?.description
    return {
      ...pageHead,
      title: `Articles`,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Articles',
        },
        {
          hid: 'description',
          name: 'description',
          content: yoastDescription,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: yoastDescription,
        },
        ...pageHead?.meta,
      ],
    }
  },
  computed: {
    wpBusy() {
      return this.$store.state.wp.isBusy
    },
    pg() {
      return this.$store.state.wp.pagination
    },
    ...mapGetters({
      wpPagination: 'wp/wpPagination',
      wpPosts: 'wp/getPosts',
    }),
  },
  methods: {
    async pageChanged(pageNumber: number) {
      if (pageNumber !== 1) {
        this.$router.push(`/articles/page/${pageNumber}`)
      }
    },
  },
  async asyncData(context) {
    const { $config, store } = context
    const { wpBaseURL } = $config
    await store.commit('wp/setPageNumber', 1)
    await store.dispatch('wp/getPosts', { context, wpBaseURL })
    const pageData = await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'articles',
    })
    store.commit('common/updateWhiteHeader', true)
    store.commit('common/updateIsHomepage', false)
    await store.dispatch('common/fetchMenu', context)
    await store.dispatch('wp/resetSelectedCategory')
    await store.dispatch('wp/getCategories', context)
    store.commit('wp/updateBusy', false)

    return {
      pageData,
    }
  },
})
